/**
 * Atomic Icons
 * 
 * Layer 1: Atomic Components
 * All SVG icon primitives - generic, domain-agnostic.
 */

// Generic icons
export { default as TrendingDownIcon } from './trending-down-icon';
export { default as TrendingUpIcon } from './trending-up-icon';
export { default as StarIcon } from './star-icon';
export { default as InfoIcon } from './info-icon';
export { default as HomeWorkIcon } from './home-work-icon';
export { default as EventRepeatIcon } from './event-repeat-icon';
export { default as CalendarIcon } from './calendar-icon';
export { default as AreaIcon } from './area-icon';
export { default as SearchIcon } from './search-icon';
export { default as FilterIcon } from './filter-icon';
export { default as VerticalSwapIcon } from './vertical-swap-icon';
export { default as GlobeIcon } from './globe-icon';
export { default as CloseIcon } from './close-icon';
export { default as MenuIcon } from './menu-icon';
export { default as BackIcon } from './back-icon';
export { default as ImagelessIcon } from './imageless-icon';
export { default as ComingSoonIcon } from './coming-soon-icon';

// Visual icons (named by what they look like, not domain usage)
export { default as BedIcon } from './bed-icon';
export { default as BathIcon } from './bath-icon';
export { default as CarIcon } from './car-icon';
export { default as SensorDoorIcon } from './sensor-door-icon';
export { default as ViewInArIcon } from './view-in-ar-icon';
export { default as LocalOfferIcon } from './local-offer-icon';
export { default as BellIcon } from './bell-icon';
export { default as UserIcon } from './user-icon';
export { default as HouseIcon } from './house-icon';
export { default as TownhouseIcon } from './townhouse-icon';
export { default as CondoIcon } from './condo-icon';
export { default as LandIcon } from './land-icon';
export { default as CommercialIcon } from './commercial-icon';
export { default as FarmIcon } from './farm-icon';
export { default as GarageIcon } from './garage-icon';
export { default as PoolIcon } from './pool-icon';
export { default as WaterfrontIcon } from './waterfront-icon';
export { default as FireplaceIcon } from './fireplace-icon';
export { default as OpenHouseIcon } from './open-house-icon';

// Heart icons
export { default as HeartIcon } from './heart-icon';
export { default as HeartOutlineIcon } from './heart-outline-icon';

// Backwards compatibility alias
export { default as SqftIcon } from './area-icon';
